import React, { useEffect, useState } from "react";

import { getLoggedInUser } from "../helpers/fakebackend_helper";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();

  const [isDashboard, setIsDashboard] = useState(false);
  const [isnewUser, setIsnewUser] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isItem, setIsItem] = useState(false);
  const [isListItem, setIsListItem] = useState(false);
  const [isProcurement, setIsProcurement] = useState(false);
  const [isDisputeOpen, setIsDisputeOpen] = useState(false);
const [isMenuOpen, setIsMenuOpen] = useState(false);
const [isAdminModule, setIsAdminModule] = useState(false)

  const [isPeople, setIsPeople] = useState(false);
  const [isPaymentReport, setIsPaymentReport] = useState(false);
  const [isSetup, setIsSetup] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [isSales, setIsSales] = useState(false);
  const [isLogs, setIsLogs] = useState(false);

  const [isPaymentType, setIsPaymentType] = useState(false);
  const [isMenuCategory, setIsMenuCategory] = useState(false);
  const [isMenuItem, setMenuItem] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [isWaiter, setIsWaiter] = useState(false);
  const [isTable, setIsTable] = useState(false);
  const authUser = getLoggedInUser();
  // console.log("authUserr", authUser);
  // const userRole = authUser?.user?.roles[0]?.toLowerCase();
  // console.log("🚀 ~ Navdata ~ userRole:", userRole);
  // const isSuperAdmin = authUser.user.roles.includes("SuperAdmin");
  // const isSuperAdmin = true;
  // console.log("isSuperAdmin", isSuperAdmin);
  // const isAdmin = true;

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }

    if (iscurrentState !== "people-management") {
      setIsPeople(false);
    }

    if (iscurrentState !== "PaymentReport") {
      setIsPaymentReport(false);
    }

    if (iscurrentState !== "payment-type") {
      setIsPaymentType(false);
    }
    if (iscurrentState !== "menu-category") {
      setIsMenuCategory(false);
    }
    if (iscurrentState !== "menu-item") {
      setMenuItem(false);
    }

    if (iscurrentState !== "setting") {
      setIsSetting(false);
    }

    if (iscurrentState !== "settings") {
      setIsWaiter(false);
    }
    if (iscurrentState !== "Table") {
      setIsTable(false);
    }
    if (iscurrentState !== "sales-report") {
      setIsSales(false);
    }
    if (iscurrentState !== "logs") {
      setIsLogs(false);
    }
    if (iscurrentState !== "user-management") {
      setIsUser(false);
    }
    if (iscurrentState !== "database-management") {
      setIsItem(false);
    }
    if (iscurrentState !== "admin") {
      setIsAdminModule(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isSetup,
    isItem,
    isPeople,

    isPaymentReport,

    isPaymentType,
    isMenuCategory,
    isMenuItem,
    isUser,
    isSetting,
    isWaiter,
    isTable,
    isSales,
    isLogs,
    isAdminModule
  ]);

  const cashierMenuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
      },
    },
  
     {
      id: "disputeModule",
      label: "Dispute Claim Module",
      icon: "bx bxs-report",
      link: "/dispute",
      parentId: "disputeModule",
      click: (e) => {
        e.preventDefault();
        setIsDisputeOpen(!isDisputeOpen);
        setIscurrentState("dispute");
        updateIconSidebar(e);
      },
      stateVariables: isDisputeOpen,
      subItems: [
        {
          id: "List",
          label: "List",
          link: "/disputeList",
          parentId: "disputeModule",
        },
        {
          id: "Reports",
          label: "Reports",
          link: "/disputeDetail",
          parentId: "disputeModule",
        },
      ],
    },
     {
      id: "memoModule",
      label: "Memo",
      icon: "bx bxs-report",
      link: "/menu",
      parentId: "memoModule",
      click: (e) => {
        e.preventDefault();
        setIsMenuOpen(!isMenuOpen);
        setIscurrentState("menu");
        updateIconSidebar(e);
      },
      stateVariables: isMenuOpen,
      subItems: [
        {
          id: "New List",
          label: "New List",
          link: "/newList",
          parentId: "memoModule",
        },
         {
          id: "Deffered List",
          label: "Deffered List",
          link: "/defferedList",
          parentId: "memoModule",
        },
        {
          id: "Initiated List",
          label: "Initiated List",
          link: "/initiatedList",
          parentId: "memoModule",
        },
        {
          id: "Pending List",
          label: "Pending List",
          link: "/pendingList",
          parentId: "memoModule",
        },
        {
          id: "Completed List",
          label: "Completed List",
          link: "/completedList",
          parentId: "memoModule",
        },
         {
          id: "Processing List",
          label: "Processing List",
          link: "/processingList",
          parentId: "memoModule",
        },
      ],
    },

     {
      id: "admin",
      label: "Admin",
      icon: "bx bxs-report",
      link: "/admin",
      parentId: "admin",
      click: (e) => {
        e.preventDefault();
        setIsAdminModule(!isAdminModule);
        setIscurrentState("admin");
        updateIconSidebar(e);
      },
      stateVariables: isAdminModule,
      subItems: [
        {
          id: "Branch",
          label: "Branch",
          link: "/branch",
          parentId: "admin",
        },
        {
          id: "Department",
          label: "Department",
          link: "/department",
          parentId: "admin",
        },
        {
          id: "Employee",
          label: "Employee",
          link: "/employee",
          parentId: "admin",
        },
         {
          id: "Dispute Types",
          label: "Dispute Types",
          link: "/dispute",
          parentId: "admin",
        },
         {
          id: "Document Types",
          label: "Document Types",
          link: "/document",
          parentId: "admin",
        },
      ],
    },

 

    {
      id: "setting",
      label: "Settings",
      icon: "ri-settings-3-line",
      link: "#",
      parentId: "setting",
      click: (e) => {
        e.preventDefault();
        setIsSetting(!isSetting);
        setIscurrentState("setting");
        updateIconSidebar(e);
      },
    },
  ];
  let filteredMenuItems;

  // if (userRole === "superadmin") {
  //   filteredMenuItems = superAdminItems;
  // } else if (userRole === "cashier") {
  //   filteredMenuItems = cashierMenuItems;
  // } else {
  //   filteredMenuItems = orgMenuItems;
  // }

  return <React.Fragment>{cashierMenuItems}</React.Fragment>;
};

export default Navdata;
